import { render } from "./DeliveryMethodsList.vue?vue&type=template&id=917669c8&scoped=true"
import script from "./DeliveryMethodsList.vue?vue&type=script&lang=js"
export * from "./DeliveryMethodsList.vue?vue&type=script&lang=js"

import "./DeliveryMethodsList.vue?vue&type=style&index=0&id=917669c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-917669c8"]])

export default __exports__